import { observer } from 'mobx-react-lite'
import { useEffect, useMemo } from 'react'
import { EmptyState } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { GuidelineStaticStore } from 'widgets/GuidelineAlert'
import { TextingHeader } from 'pages/chatbot/pages/texting/ui/TextingHeader'
import { TextingTable } from 'pages/chatbot/pages/texting/ui/TextingTable'
import {
  ChatbotDetailsProvider,
  ChatbotListContext,
  useChatbotListContext,
} from 'pages/chatbot/context'
import { useListLayoutContext } from 'pages/chatbot/layout/ListLayout/context'

const TextingUI = observer(() => {
  const { disabledLoadingOnMount } = useListLayoutContext()
  const entities = useEntitiesContext()
  const { search, setSearch, loadData, isEmpty } = useChatbotListContext()

  const guidelineStaticStore = useMemo(
    () => new GuidelineStaticStore('chatbotGuidelineHidden', entities),
    []
  )
  useEffect(() => {
    if (!disabledLoadingOnMount) {
      loadData()
    }
  }, [])
  useEffect(() => {
    return () => {
      guidelineStaticStore.dispose()
    }
  }, [])

  if (isEmpty) {
    return <EmptyState variant='default' text='No texting agents' noIcon />
  }
  return (
    <>
      <TextingHeader search={search} setSearch={setSearch} />
      <TextingTable />
    </>
  )
})

export const Texting = () => {
  const { chatbotListStore } = useListLayoutContext()
  return (
    <ChatbotListContext.Provider value={chatbotListStore}>
      <ChatbotDetailsProvider>
        <TextingUI />
      </ChatbotDetailsProvider>
    </ChatbotListContext.Provider>
  )
}
